/**
 * Localization strings for the Cevro Messenger widget
 */

export interface LocaleStrings {
  // Header
  headerTitle: string;
  headerSubtitle: string;

  // Input
  inputPlaceholder: string;

  // Pre-chat form (for visitors)
  preChatTitle: string;
  preChatSubtitle: string;
  preChatFirstNameLabel: string;
  preChatFirstNamePlaceholder: string;
  preChatEmailLabel: string;
  preChatEmailPlaceholder: string;
  preChatSubmit: string;
  preChatFirstNameRequired: string;
  preChatEmailRequired: string;
  preChatEmailInvalid: string;

  // Closed chat
  closedMessage: string;
  newConversation: string;

  // Conversation history
  conversationsTitle: string;
  newConversationButton: string;
  activeConversation: string;
  noConversations: string;
  noConversationsSubtitle: string;
  loadingConversations: string;
  loadMoreConversations: string;
  messagesCount: string;
  yesterday: string;
  closedStatus: string;
  defaultConversationTitle: string;

  // CSAT
  csatTitle: string;
  csatSubtitle: string;
  csatPlaceholder: string;
  csatPlaceholderNegative?: string;
  csatPlaceholderNeutral?: string;
  csatSubmit: string;
  csatThankYou: string;

  // Footer
  poweredBy: string;
}

/**
 * Default English strings
 */
export const defaultStrings: LocaleStrings = {
  // Header
  headerTitle: 'Cevro',
  headerSubtitle: 'We typically reply within a few minutes',

  // Input
  inputPlaceholder: 'How can we help?',

  // Pre-chat form (for visitors)
  preChatTitle: 'Start a conversation',
  preChatSubtitle: 'Please provide your contact information to get started.',
  preChatFirstNameLabel: 'First name',
  preChatFirstNamePlaceholder: 'Your first name',
  preChatEmailLabel: 'Email',
  preChatEmailPlaceholder: 'your@email.com',
  preChatSubmit: 'Start Chat',
  preChatFirstNameRequired: 'First name is required',
  preChatEmailRequired: 'Email is required',
  preChatEmailInvalid: 'Please enter a valid email',

  // Closed chat
  closedMessage: 'The agent closed the chat.',
  newConversation: 'Start New Conversation',

  // Conversation history
  conversationsTitle: 'Conversations',
  newConversationButton: 'New Conversation',
  activeConversation: 'Active',
  noConversations: 'No conversations yet',
  noConversationsSubtitle: 'Start a new conversation to get help.',
  loadingConversations: 'Loading...',
  loadMoreConversations: 'Load more',
  messagesCount: 'messages',
  yesterday: 'Yesterday',
  closedStatus: 'Closed',
  defaultConversationTitle: 'Conversation',

  // CSAT
  csatTitle: 'How was your conversation?',
  csatSubtitle: 'Your feedback helps us get better.',
  csatPlaceholder: 'Thank you! What stood out?',
  csatPlaceholderNegative: 'Sorry to hear that. What could we improve?',
  csatPlaceholderNeutral: 'Thanks for your feedback. Anything we could do better?',
  csatSubmit: 'Submit Feedback',
  csatThankYou: 'Thank you for your feedback!',

  // Footer
  poweredBy: 'Powered by Cevro AI',
};

/**
 * Merge strings with priority: defaults < client config < backend (DB)
 */
export function getStrings(
  clientOverrides?: Partial<LocaleStrings>,
  backendOverrides?: Partial<LocaleStrings>
): LocaleStrings {
  return {
    ...defaultStrings,
    ...clientOverrides,
    ...backendOverrides,
  };
}
